import React from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";

import { LinkContainer } from "react-router-bootstrap";
import "../assets/css/component/header.css";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import authService from "../services/auth.service";

import { Path } from "../constants/enum/path.emum";
import { setIsAuthenticated } from "../store/me";
import axios from "axios";

const Header = () => {
  const user = JSON.parse(localStorage.getItem("user") ?? "false");
  // console.log(user);

  if (user.accessToken) {
    axios.defaults.headers.common["Authorization"] = `${user.accessToken}`;
  }
  const me = useSelector((state: any) => state.me);
  const dispatch = useDispatch();
  const logout = async () => {
    await authService.logout().then(() => {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "ออกจากระบบสำเร็จ",
        showConfirmButton: false,
        timer: 1500,
      });
    });
    localStorage.removeItem("user");
    dispatch(
      setIsAuthenticated({ isAuthenticated: false, firstName: "", role: "" })
    );
  };

  return (
    <>
      <Navbar bg="TopBar" variant="dark" expand="lg" collapseOnSelect>
        <Container>
          {/* <LinkContainer to={Path.HOME}> */}
          <Navbar.Brand>
            {/* <h4>ระบบส่งเอกสาร</h4> */}
            ระบบส่งเอกสาร มคอ./อชว.
          </Navbar.Brand>
          {/* </LinkContainer> */}
          {/* <div className="mr-auto"> */}
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className="justify-content-end"
          >
            <Nav>
              {me.role === "Guest" && (<>
                <LinkContainer to={Path.MEMBER_INFO}>
                  <Nav.Link>หน้าหลัก</Nav.Link>
                </LinkContainer>
                <LinkContainer to={Path.FINDDOC}>
                  <Nav.Link>ค้นหาเอกสาร</Nav.Link>
                </LinkContainer>
                <LinkContainer to={Path.DOC7}>
                  <Nav.Link>มคอ.7</Nav.Link>
                </LinkContainer>
                <LinkContainer to={Path.VERIFI}>
                  <Nav.Link>ผลการทวนสอบ</Nav.Link>
                </LinkContainer>
                <LinkContainer to={Path.DOWNLOADS}>
                  <Nav.Link>ดาวน์โหลด</Nav.Link>
                </LinkContainer>
              </>)}


              {me.role === "Member" && (
                <>
                  <LinkContainer to={Path.MEMBER_INFO}>
                    <Nav.Link>หน้าหลัก</Nav.Link>
                  </LinkContainer>

                  <LinkContainer to={Path.HOME}>
                    <Nav.Link>ส่งเอกสาร</Nav.Link>
                  </LinkContainer>
                  <LinkContainer to={Path.DOC7}>
                    <Nav.Link>มคอ.7</Nav.Link>
                  </LinkContainer>

                  <LinkContainer to={Path.VERIFI}>
                    <Nav.Link>ผลการทวนสอบ</Nav.Link>
                  </LinkContainer>

                  <LinkContainer to={Path.FINDDOC}>
                    <Nav.Link>ค้นหาเอกสาร</Nav.Link>
                  </LinkContainer>
                  <LinkContainer to={Path.SUMMARY}>
                    <Nav.Link>แบบสรุป</Nav.Link>
                  </LinkContainer>
                  <LinkContainer to={Path.DOWNLOADS}>
                    <Nav.Link>ดาวน์โหลด</Nav.Link>
                  </LinkContainer>
                </>
              )}
              {me.role === "Admin" && (
                <>
                  <LinkContainer to={Path.USERS}>
                    <Nav.Link>จัดการ Users</Nav.Link>
                  </LinkContainer>

                  <LinkContainer to={Path.CURRICULUMS}>
                    <Nav.Link>จัดการหลักสูตร</Nav.Link>
                  </LinkContainer>
                  <LinkContainer to={Path.SCHEDULES}>
                    <Nav.Link>จัดการกำหนดการ</Nav.Link>
                  </LinkContainer>

                  <LinkContainer to={Path.REPORT}>
                    <Nav.Link>รายงาน</Nav.Link>
                  </LinkContainer>
                  <LinkContainer to={Path.FINDDOC}>
                    <Nav.Link>ค้นหาเอกสาร</Nav.Link>
                  </LinkContainer>

                  <LinkContainer to={Path.DOC7}>
                    <Nav.Link>มคอ.7</Nav.Link>
                  </LinkContainer>

                  <LinkContainer to={Path.VERIFI}>
                    <Nav.Link>ผลการทวนสอบ</Nav.Link>
                  </LinkContainer>

                  <LinkContainer to={Path.SUMMARY}>
                    <Nav.Link>แบบสรุป</Nav.Link>
                  </LinkContainer>

                  <LinkContainer to={Path.SETTINGS}>
                    <Nav.Link>ตั้งค่า</Nav.Link>
                  </LinkContainer>

                  <LinkContainer to={Path.DOWNLOADS}>
                    <Nav.Link>ดาวน์โหลด</Nav.Link>
                  </LinkContainer>
                </>
              )}
              <NavDropdown
                id="nav-dropdown-dark-example"
                title={`สวัสดีคุณ ${me.firstName}`}
                menuVariant="dark"
              >
                <NavDropdown.Item>
                  <LinkContainer to={Path.PROFILE}>
                    <Nav.Link>Profile</Nav.Link>
                  </LinkContainer>
                </NavDropdown.Item>

                <NavDropdown.Divider />
                {/* <LinkContainer to="/logout"> */}
                <NavDropdown.Item onClick={logout}>ออกจากระบบ</NavDropdown.Item>
                {/* </LinkContainer> */}
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
          {/* </div> */}
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
